export const experienceData = [
    {
        id: 1,
        company: 'DRDO, Ministry of Defence, Govt. of India. Internship',
        jobtitle: 'Full-Stack Development (Intern)',
        startYear: 'May-2023',
        endYear: 'Jun-2023'
    },
    {
        id: 2,
        company: 'Freelancer',
        jobtitle: 'Full-Stack Developer',
        startYear: 'Jun 2022',
        endYear: 'Present'
    },
    {
        id: 3,
        company: 'Learning New Technology For Everyday',
        jobtitle: 'Self Learning',
        startYear: '2020',
        endYear: 'Present'
    },
]